var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "divHasTooltip",
      staticClass: "hasTooltip",
      class: `${_vm.active ? "enable" : "disable"} ${_vm.classCustom}`,
      on: {
        mouseover: function ($event) {
          return _vm.showToolTip($event)
        },
        mouseleave: _vm.hideToolTip,
        click: _vm.handlerClick,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }